const conf={
  apiUrl:'https://bbpv-back.bachibouzouk.net',
  docUrl:'https://bbpv-doc.bachibouzouk.net',
  urlsPv:['https://www.poissonsvolants.com','https://pv-front.lefil.org'],
  urlsBb:['https://www.bachibouzouk.net','https://bb-front.lefil.org'],
  authToken: 'At2yWxPSjq_crSAl7O5M7KsFUjgxSbcx',
}
export default conf;
